export default __webpack_public_path__ + "static/media/caffenio-logo-small.1f9f680e.png";